import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private subject = new Subject<any>();
  private cartCountSubject = new Subject<any>();
  private storeColorSchemeSubject = new Subject<any>();
  private superAdminChartSubject = new Subject<any>();
  private storeAdminChartSubject = new Subject<any>();
  private FPCSubject = new Subject<any>();

  sendMessage(message: any) {
    this.subject.next({ message });
  }
  clearMessage() {
    this.subject.next(true);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  sendCartCount(message: any) {
    this.cartCountSubject.next({ message });
  }
  getCartCount(): Observable<any> {
    return this.cartCountSubject.asObservable();
  }
  clearCartCount() {
    this.cartCountSubject.next(true);
  }

  // Color scheme ----------- STARTS -----------
  setColorScheme(colorScheme: any) {
    this.storeColorSchemeSubject.next({ colorScheme });
  }
  clearColorScheme() {
    this.storeColorSchemeSubject.next(true);
  }
  getColorScheme(): Observable<any> {
    return this.storeColorSchemeSubject.asObservable();
  }
  // Color scheme ----------- ENDS -------------

  // Super Admin chart data ----------- STARTS -----------
  setSuperAdminChartData(chartData: any) {
    this.superAdminChartSubject.next({ chartData });
  }
  clearSuperAdminChartData() {
    this.superAdminChartSubject.next(true);
  }
  getSuperAdminChartData(): Observable<any> {
    return this.superAdminChartSubject.asObservable();
  }
  // Super Admin chart data ----------- ENDS -------------

  // Store Admin chart data ----------- STARTS -----------
  setStoreAdminChartData(chartData: any) {
    this.storeAdminChartSubject.next({ chartData });
  }
  clearStoreAdminChartData() {
    this.storeAdminChartSubject.next(true);
  }
  getStoreAdminChartData(): Observable<any> {
    return this.storeAdminChartSubject.asObservable();
  }
  // Store Admin chart data ----------- ENDS -------------


  // Featured product component ----------- STARTS -----------
  setFPCChange(val: boolean) {
    this.FPCSubject.next(val);
  }
  clearFPCChange() {
    this.FPCSubject.next(true);
  }
  getFPCChange(): Observable<any> {
    return this.FPCSubject.asObservable();
  }
  // Featured product component ----------- ENDS -------------
}
